// The El Rayes mark — a six-armed ship's wheel that reads equally as a fan.
//
// Inlined as a component rather than loaded from a file so it can inherit
// `currentColor`, which BRAND.md requires: "المارك بيرث اللون من currentColor
// — لوّنه بالـtoken مش بهيكس". An <img> could not do that.
//
// Two cuts, and the size decides which: below 24px the outer handles collide
// and turn to mush, so `mark-compact.svg` drops them. `<RayesMark size={n} />`
// picks for you.
//
// Never rotate, shadow, gradient, or restroke it, and never mirror it in RTL —
// COMPONENTS.md lists the mark alongside clocks and media controls as a glyph
// that does not flip.

const FULL = [
    ["24.00", "18.80", "24.00", "9.20"], ["24.00", "9.20", "24.00", "3.40"],
    ["28.50", "21.40", "36.82", "16.60"], ["36.82", "16.60", "41.84", "13.70"],
    ["28.50", "26.60", "36.82", "31.40"], ["36.82", "31.40", "41.84", "34.30"],
    ["24.00", "29.20", "24.00", "38.80"], ["24.00", "38.80", "24.00", "44.60"],
    ["19.50", "26.60", "11.18", "31.40"], ["11.18", "31.40", "6.16", "34.30"],
    ["19.50", "21.40", "11.18", "16.60"], ["11.18", "16.60", "6.16", "13.70"],
];

// The compact cut keeps only the inner spokes — the outer handles are what
// stop reading first as the mark gets small.
const COMPACT = FULL.filter((_, i) => i % 2 === 0);

export default function RayesMark({ size = 32, className = "", title = "الريّس" }) {
    const spokes = size < 24 ? COMPACT : FULL;
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 48 48"
            fill="none"
            role="img"
            aria-label={title}
            className={className}
            style={{ flex: "0 0 auto" }}
        >
            <g stroke="currentColor" strokeWidth="3.4" strokeLinecap="round">
                <circle cx="24" cy="24" r="14.8" />
                {spokes.map(([x1, y1, x2, y2], i) => (
                    <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} />
                ))}
            </g>
            <circle cx="24" cy="24" r="4.6" fill="currentColor" />
        </svg>
    );
}

// Mark only by default. The wheel IS the logo; setting the name beside it in
// Alexandria repeated a word the mark already stands for, and in the header it
// read as the brand written twice. `showName` stays for the rare surface that
// has no other context — a printed document header, say.
export function RayesLogo({ size = 32, showName = false, className = "" }) {
    return (
        <span
            className={`rayes-logo ${className}`}
            style={{ display: "inline-flex", alignItems: "center", gap: "var(--sp-2)" }}
        >
            <RayesMark size={size} />
            {showName && (
                <span
                    style={{
                        fontFamily: "var(--font-ar-display)",
                        fontWeight: 800,
                        fontSize: `${Math.round(size * 0.62)}px`,
                        letterSpacing: "-.01em",
                        lineHeight: 1,
                        color: "currentColor",
                    }}
                >
                    الريّس
                </span>
            )}
        </span>
    );
}
